import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../../helpers/history';

// 引入 ECharts 主模块
import echarts from 'echarts/lib/echarts';
import 'echarts-gl';

// 引入柱状图
import "echarts/lib/chart/bar";

// 引入提示框和标题组件
import "echarts/lib/component/tooltip";
import 'echarts/lib/component/title';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/scatter';//effectScatter
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/axisPointer';
import 'echarts/lib/component/markArea';
import 'echarts/lib/component/legendScroll';

import { Layout, Table, Divider, message } from 'antd';
import { getChartOption } from './chartOptions/index';
import emitter from '../Evt.js';
import { equal } from 'assert';

const { Content } = Layout;

var languageMessages = window.appLocale.messages;


var statistics = [
    { 'sName': languageMessages['annualizedRateOfReturn'], 'xData': [], 'yName': '(%)', "data": [], color: '#5470c6', markPoint: { symbol: 'none', data: [], color: '#5470c6' }, minInterval: 0 },
    { 'sName': languageMessages['totalPnl'], 'xData': [], 'yName': '($)', "data": [], color: '#5470c6', markPoint: { symbol: 'none', data: [], color: '#5470c6' }, minInterval: 0 },
    { 'sName': languageMessages['profitFactor'], 'xData': [], 'yName': '', "data": [], color: '#5470c6', markPoint: { symbol: 'none', data: [], color: '#5470c6' }, minInterval: 0 },
    { 'sName': languageMessages['maxdrawdown'], 'xData': [], 'yName': '(%)', "data": [], color: '#5470c6', markPoint: { symbol: 'none', data: [], color: '#5470c6' }, minInterval: 0 },
    { 'sName': languageMessages['totalTrades'], 'xData': [], 'yName': languageMessages['number'], "data": [], color: '#5470c6', markPoint: { symbol: 'none', data: [], color: '#5470c6' }, minInterval: 1 }
];

var incomes = {
    'sName': languageMessages['incomeCurve'],
    'xName': languageMessages['date'],
    'xData': [],
    'yName': languageMessages['totalRet'] + '(%)',
    'data': [
        /**
        {
            'name': '沪深300',
            'color': '#CE0000',
            'data': []//[0.00, - 0.18, -0.55, 0.19, -0.96, 0.29, 0.26]
        },
        {
            'name': languageMessages['thisStrategy'],
            'color': 'blue',
            'data': []//[0.73, 1.06, 1.76, 3.19, 1.98, 3.67, 3.26]
        }*/
        {
            'name': languageMessages['strategyGains'],
            'color': '#ee6666',
            'data': []//[0.00, - 0.18, -0.55, 0.19, -0.96, 0.29, 0.26]
        },
        {
            'name': languageMessages['individualStockIncome'],
            'color': '#5470c6',
            'data': []//[0.73, 1.06, 1.76, 3.19, 1.98, 3.67, 3.26]
        },
        {
            'name': languageMessages['individualStocks+strategyStackingIncome'],
            'color': '#990000',
            'data': []//[0.73, 1.06, 1.76, 3.19, 1.98, 3.67, 3.26]
        }
    ],
};

var equitys = {
    'sName': languageMessages['equityCurve'],
    'xName': languageMessages['date'],
    'xData': [],//['20200102', '20200103', '20200106', '20200107', '20200108', '20200109', '20200110'],
    'data': [
        {
            'type': 1,
            'name': 'symbol',
            'color': '#CE0000',
            'data': []//[1000000.00, 998246.70, 994475.20, 1001924.00, 990385.80, 1002921.00, 1002635.00]
        },
        {
            'type': 0,
            'name': languageMessages['equity'],
            'color': 'blue',
            'data': []//[1007270.00, 1010562.00, 1017566.00, 1031863.00, 1019762.00, 1036715.00, 1032639.00]
        },
        {
            'type': 0,
            'name': languageMessages['cash'],
            'data': []//[7340.11, 10632.11, 17636.11, 31933.11, 19832.11, 36785.11, 1032639.00]
        }
    ],
};

var colors = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];

class BacktestResult extends Component {
    constructor(props) {
        super(props);

        this.charts = {
            "statistics": null,
            "income": null,
            "equity": null
        }
        
        this.state = {
            spinLoadding: false,

            statisticsResult: [],

            conditions: [],

            income: '',
            equity: '',
            trade: '',

            dataSource: [],
        }
    }
    
    componentDidMount() {
        const { statisticsResult } = this.props;

        this.setBacktestResult(statisticsResult);

        emitter.addListener('initPage', () => {
            this.init();
        });
    }

    componentWillMount() {
        this.init();
    }
    
    init() {
        
    }

    resizeChart() {
        var statistics = this.charts['statistics'];
        var incomeChart = this.charts['income'];
        var equityChart = this.charts['equity'];
        window.onresize = function () {
            if (incomeChart != null) incomeChart.resize();
            if (equityChart != null) equityChart.resize();

            if (statistics != null) {
                for (let i = 0; i < 5; i++) {
                    statistics["statistics-" + i].resize();
                }
            }
        }
    }

    setEquityData(chartName, chartData) {
        this.charts[chartName] = echarts.init(document.getElementById(chartName));
        this.charts[chartName].setOption(getChartOption(chartName, chartData));

        this.charts[chartName].resize();

        this.resizeChart();
    }

    setIncomeData(chartName, chartData) {
        this.charts[chartName] = echarts.init(document.getElementById(chartName));
        this.charts[chartName].setOption(getChartOption(chartName, chartData));

        this.charts[chartName].resize();

        this.resizeChart();
    }

    setStatisticsData(chartName, chartData) {
        this.charts[chartName] = {};

        let pdiv = document.getElementById(chartName)
        pdiv.innerHTML = ""
        for (let i = 0; i < chartData.length; i++) {
            let div = document.createElement("div");//创建一个div元素
            div.style.width = "33.3%";
            div.style.height = "360px";

            var ids = chartName + "-" + i;
            div.setAttribute("id", ids);
            pdiv.appendChild(div)

            //chartData[i].color = colors[i];

            this.charts[chartName][ids] = echarts.init(document.getElementById(ids));
            this.charts[chartName][ids].setOption(getChartOption(chartName, chartData[i]));

            this.charts[chartName][ids].resize();
        }

        this.resizeChart();
    }

    keepDecimals(value, sign) {
        value = value == null ? '' : value;
        if (value !== '') {
            //value = value.replace(/([0-9]+.[0-9]{2})[0-9]*/, "$1");
            value = Number(value).toFixed(2);
            value += sign;
        }

        return value;
    }

    setBacktestResult(statisticsResult) {
        var conditions = [];

        this.charts = {
            "statistics": null,
            "income": null,
            "equity": null
        };

        for (var i = 0; i < 5; i++) {
            statistics[i].xData = [];
            statistics[i].data = [];
            statistics[i].markPoint = { symbol: 'none', data: [], color: '#fac858' };
        }

        incomes.xData = [];
        incomes.data[0].data = [];
        incomes.data[1].data = [];
        incomes.data[2].data = [];

        equitys.xData = [];
        equitys.data[0].data = [];
        equitys.data[1].data = [];
        equitys.data[2].data = [];

        var income = [];
        var equity = '';
        var trade = '';

        var dataSource = [];

        if (statisticsResult.length > 0) {
            let maxProfitFactor = 0;
            let profitFactorItem = [];
            for (var item in statisticsResult) {
                conditions.push({ 'id': statisticsResult[item].backtestId, 'name': statisticsResult[item].strategyName });

                statistics[0].xData.push(statisticsResult[item].strategyName);
                statistics[1].xData.push(statisticsResult[item].strategyName);
                statistics[2].xData.push(statisticsResult[item].strategyName);
                statistics[3].xData.push(statisticsResult[item].strategyName);
                statistics[4].xData.push(statisticsResult[item].strategyName);

                var annualizedRateOfReturn = this.keepDecimals(statisticsResult[item].annualizedRateOfReturn, '');
                var totalPnl = this.keepDecimals(statisticsResult[item].totalPnl, '');
                var profitFactor = this.keepDecimals(statisticsResult[item].profitFactor, '');
                var maxDrawdown = this.keepDecimals(statisticsResult[item].maxDrawdown, '');

                maxDrawdown = maxDrawdown > 0 ? 0 - maxDrawdown : maxDrawdown;

                if (annualizedRateOfReturn >= 0) {
                    statistics[0].data.push(annualizedRateOfReturn);
                } else {
                    statistics[0].data.push({ value: annualizedRateOfReturn, label: { position: 'bottom' } });
                }

                if (totalPnl >= 0) {
                    statistics[1].data.push(totalPnl);
                } else {
                    statistics[1].data.push({ value: totalPnl, label: { position: 'bottom' } });
                }

                if (profitFactor >= 100000) {
                    var color = window.webType === 'US' ? 'Darkgreen' : '#aa0000';
                    //statistics[2].markPoint.symbol = 'pin';
                    statistics[2].markPoint.color = color;
                    statistics[2].markPoint.data.push({ value: languageMessages['noLoss'], xAxis: parseInt(item), yAxis: profitFactor / 2 });
                    statistics[2].data.push({
                        value: profitFactor,
                        label: { position: profitFactor >= 0 ? 'top' : 'bottom' },
                        itemStyle: {
                            color: color
                        }
                    });

                    profitFactorItem.push(item);
                } else {
                    if (profitFactor >= 0) statistics[2].data.push(profitFactor);
                    else statistics[2].data.push({ value: profitFactor, label: { position: 'bottom' } });

                    if (profitFactor > maxProfitFactor) maxProfitFactor = profitFactor;
                }

                if (maxDrawdown >= 0) {
                    statistics[3].data.push(maxDrawdown);
                } else {
                    statistics[3].data.push({ value: maxDrawdown, label: { position: 'bottom' } });
                }
                
                if (statisticsResult[item].totalTrades >= 0) {
                    statistics[4].data.push(statisticsResult[item].totalTrades);
                } else {
                    statistics[4].data.push({ value: statisticsResult[item].totalTrades, label: { position: 'bottom' } });
                }
            }

            if (profitFactorItem.length > 0) {
                for (var item in profitFactorItem) {
                    if (maxProfitFactor > 0) {
                        statistics[2].data[profitFactorItem[item]].value = maxProfitFactor;
                        statistics[2].markPoint.data[item].yAxis = maxProfitFactor / 3;
                    }
                }
            }

            if (conditions.length > 0) {
                income = conditions[0].id;//.push(conditions[0].id);
                equity = conditions[0].id;
                trade = conditions[0].id;

                var rateOfReturn = statisticsResult[0].equityCurve.rateOfReturn;
                var bRateOfReturn = statisticsResult[0].equityCurve.bRateOfReturn;

                incomes.xData = statisticsResult[0].equityCurve.date;
                //incomes.data[0].name = window.webType === 'US' ? languageMessages['SP500'] : languageMessages['CSI300'];
                incomes.data[0].data = rateOfReturn;
                //incomes.data[1].name = statisticsResult[0].strategyName;
                incomes.data[1].data = bRateOfReturn;

                var superimposedIncome = [];
                for (var ii in rateOfReturn) {
                    var tmp = parseFloat(rateOfReturn[ii]) + parseFloat(bRateOfReturn[ii]);
                    superimposedIncome.push(this.keepDecimals(tmp.toString(), ''));
                }

                incomes.data[2].data = superimposedIncome;
                /**
                incomes.data.push({
                    'name': statisticsResult[0].strategyName,
                    'color': colors[0],
                    'data': statisticsResult[0].equityCurve.rateOfReturn
                });
                */
                
                equitys.xData = statisticsResult[0].equityCurve.date;
                equitys.data[0].name = statisticsResult[0].symbolCode;//window.webType === 'US' ? languageMessages['SP500'] : languageMessages['CSI300'];
                equitys.data[0].data = statisticsResult[0].equityCurve.bEquity;
                equitys.data[1].name = statisticsResult[0].strategyName;
                equitys.data[1].data = statisticsResult[0].equityCurve.equity;
                equitys.data[2].data = statisticsResult[0].equityCurve.cash;

                if (statisticsResult[0].trades.length > 0) {
                    var trades = statisticsResult[0].trades;

                    var sequence = 1;
                    var index = 1;
                    for (var item in trades) {
                        var pnl = parseFloat(trades[item].pnl);
                        var pnlPercent = parseFloat(trades[item].pnlPercent);

                        var direction = '';
                        var tradeTime = trades[item].entryDatetime;
                        var strikePrice = '';
                        var volume = Math.abs(trades[item].quantity);
                        var turnover = 0;
                        if (trades[item].direction == 'L') {
                            direction = 'L';
                        } else {
                            direction = 'S';
                        }

                        tradeTime = trades[item].entryDatetime;
                        strikePrice = trades[item].entryPrice;
                        var tmpStrikePrice = parseFloat(strikePrice);
                        turnover = volume * tmpStrikePrice;

                        dataSource.push({
                            key: index,//trades[item].backtestId,
                            sequence: sequence,
                            symbolName: trades[item].symbol,
                            tradeTime: tradeTime,
                            strikePrice: strikePrice,
                            direction: direction,
                            volume: volume,
                            turnover: turnover.toFixed(2),
                            pnl: '',
                            pnlp: ''
                        });

                        index++;

                        if (trades[item].direction == 'L') {
                            direction = 'S';
                        } else {
                            direction = 'L';
                        }

                        tradeTime = trades[item].exitDatetime;
                        strikePrice = trades[item].exitPrice;
                        var tmpStrikePrice = parseFloat(strikePrice);
                        turnover = volume * tmpStrikePrice;

                        dataSource.push({
                            key: index,//trades[item].backtestId,
                            sequence: '',
                            symbolName: '',
                            tradeTime: tradeTime,
                            strikePrice: strikePrice,
                            direction: direction,
                            volume: volume,
                            turnover: turnover.toFixed(2),
                            pnl: pnl.toFixed(2),
                            pnlp: pnlPercent.toFixed(2)
                        });

                        sequence++;
                        index++;
                        /**
                        var bpUsed = parseFloat(trades[item].bpUsed);
                        var pnl = parseFloat(trades[item].pnl);
                        var pnlPercent = parseFloat(trades[item].pnlPercent);
                        dataSource.push({
                            key: index,//trades[item].backtestId,
                            sequence: index,
                            symbolName: trades[item].symbol,
                            entryDate: trades[item].entryDatetime,
                            entryPrice: trades[item].entryPrice,
                            direction: trades[item].direction,
                            quantity: trades[item].quantity,
                            exitDate: trades[item].exitDatetime,
                            exitPrice: trades[item].exitPrice,
                            pnl: pnl.toFixed(2),
                            pnlp: pnlPercent.toFixed(2),
                            initbp: bpUsed.toFixed(2),
                            exitInfo: languageMessages[trades[item].closeInfo],
                            remark: trades[item].memo
                        });

                        index++;
                        */
                    }
                }
            }
        }

        this.setStatisticsData("statistics", statistics);
        this.setIncomeData("income", incomes);
        this.setEquityData("equity", equitys);

        this.setState({ conditions, income, equity, trade, dataSource, statisticsResult });
    }

    componentWillReceiveProps(props) {
        const { statisticsResult } = props;

        if (this.state.statisticsResult == statisticsResult) return;

        this.setBacktestResult(statisticsResult);
    }

    onSelectConditionByIncome = e => {
        var { income } = this.state;

        try {
            var tags = e.currentTarget.getAttribute('data-value');
            if (income == tags) return;

            var nodes = e.target.parentNode.childNodes;
            for (var i = 0; i < nodes.length; i++) {
                var dd = nodes[i].getAttribute('data-value');
                if (tags !== dd) {
                    if (nodes[i].classList.contains("checked")) {
                        nodes[i].classList.remove("checked");
                    }
                }
            }

            e.target.classList.add("checked");
            income = tags;

            /**
            if (e.target.classList.contains("checked")) {
                e.target.classList.remove("checked");

                if (income.length <= 0) return;
                income = income.filter(function (item) { return item !== tags });
            } else {
                let count = income.length;
                if (count >= 3) {
                    message.warning(languageMessages['hawkeyeUpperLimit'], 5);
                    return;
                }

                e.target.classList.add("checked");

                income.push(tags);
            }
            */

            const { statisticsResult } = this.props;

            var tmpIncomes = statisticsResult.filter(function (e) { return income == e.backtestId; });
            if (tmpIncomes.length > 0) {

                var rateOfReturn = tmpIncomes[0].equityCurve.rateOfReturn;
                var bRateOfReturn = tmpIncomes[0].equityCurve.bRateOfReturn;

                incomes.xData = tmpIncomes[0].equityCurve.date;
                incomes.data[0].data = rateOfReturn;
                //incomes.data[1].name = tmpIncomes[0].strategyName;
                incomes.data[1].data = bRateOfReturn;

                var superimposedIncome = [];
                for (var ii in rateOfReturn) {
                    var tmp = parseFloat(rateOfReturn[ii]) + parseFloat(bRateOfReturn[ii]);
                    superimposedIncome.push(this.keepDecimals(tmp.toString(), ''));
                }

                incomes.data[2].data = superimposedIncome;
                /**
                incomes.data.push({
                    'name': statisticsResult[0].strategyName,
                    'color': colors[0],
                    'data': statisticsResult[0].equityCurve.rateOfReturn
                });
                */

                this.setIncomeData("income", incomes);
            }

            this.setState({ income });
        } catch (e) { }
    }

    onSelectConditionByEquity = e => {
        var { equity } = this.state;

        try {
            var tags = e.currentTarget.getAttribute('data-value');
            if (equity == tags) return;

            var nodes = e.target.parentNode.childNodes;
            for (var i = 0; i < nodes.length; i++) {
                var dd = nodes[i].getAttribute('data-value');
                if (tags !== dd) {
                    if (nodes[i].classList.contains("checked")) {
                        nodes[i].classList.remove("checked");
                    }
                }
            }

            e.target.classList.add("checked");
            equity = tags;

            const { statisticsResult } = this.props;

            var tmpEquitys = statisticsResult.filter(function (e) { return e.backtestId == equity; });
            if (tmpEquitys.length > 0) {
                equitys.xData = tmpEquitys[0].equityCurve.date;
                equitys.data[0].data = tmpEquitys[0].equityCurve.bEquity;
                equitys.data[1].name = tmpEquitys[0].strategyName;
                equitys.data[1].data = tmpEquitys[0].equityCurve.equity;
                equitys.data[2].data = tmpEquitys[0].equityCurve.cash;

                this.setEquityData("equity", equitys);
            }

            this.setState({ equity });
        } catch (e) { }
    }

    onSelectConditionByTrades = e => {
        var { trade } = this.state;

        try {
            var tags = e.currentTarget.getAttribute('data-value');
            if (trade == tags) return;

            var nodes = e.target.parentNode.childNodes;
            for (var i = 0; i < nodes.length; i++) {
                var dd = nodes[i].getAttribute('data-value');
                if (tags !== dd) {
                    if (nodes[i].classList.contains("checked")) {
                        nodes[i].classList.remove("checked");
                    }
                }
            }

            e.target.classList.add("checked");
            trade = tags;

            var dataSource = [];

            var tmpTrades = this.props.statisticsResult.filter(function (e) { return e.backtestId == trade; });
            if (tmpTrades.length > 0) {
                var trades = tmpTrades[0].trades;

                var sequence = 1;
                var index = 1;
                for (var item in trades) {
                    var pnl = parseFloat(trades[item].pnl);
                    var pnlPercent = parseFloat(trades[item].pnlPercent);

                    var direction = '';
                    var tradeTime = trades[item].entryDatetime;
                    var strikePrice = '';
                    var volume = Math.abs(trades[item].quantity);
                    var turnover = 0;
                    if (trades[item].direction == 'L') {
                        direction = 'L';
                    } else {
                        direction = 'S';
                    }

                    tradeTime = trades[item].entryDatetime;
                    strikePrice = trades[item].entryPrice;
                    var tmpStrikePrice = parseFloat(strikePrice);
                    turnover = volume * tmpStrikePrice;

                    dataSource.push({
                        key: index,//trades[item].backtestId,
                        sequence: sequence,
                        symbolName: trades[item].symbol,
                        tradeTime: tradeTime,
                        strikePrice: strikePrice,
                        direction: direction,
                        volume: volume,
                        turnover: turnover.toFixed(2),
                        pnl: '',
                        pnlp: ''
                    });

                    index++;

                    if (trades[item].direction == 'L') {
                        direction = 'S';
                    } else {
                        direction = 'L';
                    }

                    tradeTime = trades[item].exitDatetime;
                    strikePrice = trades[item].exitPrice;
                    var tmpStrikePrice = parseFloat(strikePrice);
                    turnover = volume * tmpStrikePrice;

                    dataSource.push({
                        key: index,//trades[item].backtestId,
                        sequence: '',
                        symbolName: '',
                        tradeTime: tradeTime,
                        strikePrice: strikePrice,
                        direction: direction,
                        volume: volume,
                        turnover: turnover.toFixed(2),
                        pnl: pnl.toFixed(2),
                        pnlp: pnlPercent.toFixed(2)
                    });

                    index++;
                    sequence++;
                    /**
                    var bpUsed = parseFloat(trades[item].bpUsed);
                    var pnl = parseFloat(trades[item].pnl);
                    var pnlPercent = parseFloat(trades[item].pnlPercent);
                    dataSource.push({
                        key: index,//trades[item].backtestId,
                        sequence: index,
                        symbolName: trades[item].symbol,
                        entryDate: trades[item].entryDatetime,
                        entryPrice: trades[item].entryPrice,
                        direction: trades[item].direction,
                        quantity: trades[item].quantity,
                        exitDate: trades[item].exitDatetime,
                        exitPrice: trades[item].exitPrice,
                        pnl: pnl.toFixed(2),
                        pnlp: pnlPercent.toFixed(2),
                        initbp: bpUsed.toFixed(2),
                        exitInfo: trades[item].closeInfo,
                        remark: trades[item].memo
                    });

                    index++;
                    */
                }
            }
            
            this.setState({ trade, dataSource });
        } catch (e) { }
    }
    

    render() {
        var { conditions, income, equity, trade, dataSource } = this.state;

        const columns = [
            {
                title: languageMessages['sequence'],
                dataIndex: 'sequence',
                align: 'right',
                width: 50
            }, {
                title: languageMessages['symbolCode'],
                dataIndex: 'symbolName',
                //sorter: (a, b) => a.symbolName < b.symbolName ? -1 : a.symbolName > b.symbolName ? 1 : 0,
                //sortDirections: ['descend', 'ascend'],
                //render: (text, record) => <a onClick={() => this.selectRow(record)}>{text}</a>,
            }, {
                title: languageMessages['direction'],
                dataIndex: 'direction',
                //sorter: (a, b) => a.direction < b.direction ? -1 : a.direction > b.direction ? 1 : 0,
                //sortDirections: ['descend', 'ascend'],
                render: (text, record) => (
                    <span>
                        {languageMessages.hasOwnProperty(record.direction) ? languageMessages[record.direction] : record.direction}
                    </span>
                )
            }, {
                title: languageMessages['tradeTimes'],
                dataIndex: 'tradeTime',
                //sorter: (a, b) => a.tradeTimes - b.tradeTimes,
                //sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['strikePrice'],
                dataIndex: 'strikePrice',
                align: 'right',
                //sorter: (a, b) => a.strikePrice - b.strikePrice,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['volume'],
                dataIndex: 'volume',
                align: 'right',
                //sorter: (a, b) => a.volume - b.volume,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['turnover'],
                dataIndex: 'turnover',
                align: 'right',
                //sorter: (a, b) => a.turnover - b.turnover,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['pnls'],
                dataIndex: 'pnl',
                align: 'right',
                //sorter: (a, b) => a.pnl - b.pnl,
                //sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['pnl'] !== '' && row['pnl'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }, {
                title: languageMessages['pnl'] + '(%)',
                dataIndex: 'pnlp',
                align: 'right',
                //sorter: (a, b) => a.pnlp - b.pnlp,
                //sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['pnlp'] !== '' && row['pnlp'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }
        ];
        /**
        const columns = [
            {
                title: languageMessages['sequence'],
                dataIndex: 'sequence',
                align: 'right',
                width: 50
            }, {
                title: languageMessages['symbolCode'],
                dataIndex: 'symbolName',
                sorter: (a, b) => a.symbolName < b.symbolName ? -1 : a.symbolName > b.symbolName ? 1 : 0,
                sortDirections: ['descend', 'ascend'],
                //render: (text, record) => <a onClick={() => this.selectRow(record)}>{text}</a>,
            }, {
                title: languageMessages['entryDate'],
                dataIndex: 'entryDate',
                sorter: (a, b) => a.entryDate - b.entryDate,
                sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['entryPrice'],
                dataIndex: 'entryPrice',
                align: 'right',
                sorter: (a, b) => a.entryPrice - b.entryPrice,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['direction'],
                dataIndex: 'direction',
                sorter: (a, b) => a.direction < b.direction ? -1 : a.direction > b.direction ? 1 : 0,
                sortDirections: ['descend', 'ascend'],
                render: (text, record) => (
                    <span>
                        {languageMessages.hasOwnProperty(record.direction) ? languageMessages[record.direction] : record.direction}
                    </span>
                )
            }, {
                title: languageMessages['quantity'],
                dataIndex: 'quantity',
                align: 'right',
                sorter: (a, b) => a.quantity - b.quantity,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['exitDate'],
                dataIndex: 'exitDate',
                sorter: (a, b) => a.exitDate - b.exitDate,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['exitPrice'],
                dataIndex: 'exitPrice',
                align: 'right',
                sorter: (a, b) => a.exitPrice - b.exitPrice,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['pnl'],
                dataIndex: 'pnl',
                align: 'right',
                sorter: (a, b) => a.pnl - b.pnl,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['pnl'] + '（%）',
                dataIndex: 'pnlp',
                align: 'right',
                sorter: (a, b) => a.pnlp - b.pnlp,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['initbp'],
                dataIndex: 'initbp',
                align: 'right',
                sorter: (a, b) => a.initbp - b.initbp,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['exitInfo'],
                dataIndex: 'exitInfo',
                render: (text, record) => (
                    <span>
                        {languageMessages.hasOwnProperty(record.exitInfo) ? languageMessages[record.exitInfo] : record.exitInfo}
                    </span>
                )
            }, {
                title: languageMessages['remark'],
                dataIndex: 'remark'
            },
        ];
        */
        var className = window.webType === 'US' ? 'common-tag common-tag-us' : 'common-tag';

        return (<Content>
            <div className='common-title'><Divider type="vertical" />{languageMessages['backtestDetails']}</div>
            <div id="statistics" style={{ display: "flex", flexWrap: "wrap", marginTop: "20px" }} > </div>

            <div className='common-title'><Divider type="vertical" />{languageMessages['fundsCurve']}</div>
            <div>
                {conditions.map((tag, index) => (
                    <div key={index} className={income == tag.id ? className + " checked" : className} onClick={this.onSelectConditionByIncome} data-value={tag.id}>{tag.name}</div>
                ))}
            </div>
            <div id="income" style={{ height: "500px", marginTop: "20px" }} > </div>

            <div>
                {conditions.map((tag, index) => (
                    <div key={index} className={equity == tag.id ? className + " checked" : className} onClick={this.onSelectConditionByEquity} data-value={tag.id}>{tag.name}</div>
                ))}
            </div>
            <div id="equity" style={{ height: "500px", marginTop: "20px" }} > </div>

            <div className='common-title'><Divider type="vertical" />{languageMessages['tradeDetails']}</div>
            <div>
                {conditions.map((tag, index) => (
                    <div key={index} className={trade == tag.id ? className + " checked" : className} onClick={this.onSelectConditionByTrades} data-value={tag.id}>{tag.name}</div>
                ))}
            </div>

            <Table bordered size='small' locale={{ emptyText: ' ' }} columns={columns} dataSource={dataSource} pagination={dataSource.length >= 60 ? { pageSize: 60 } : false} />

        </Content>);
    }
}

export { BacktestResult as default }

/**
function mapStateToProps(state) {
    return state.backtest;
}

const page = connect(mapStateToProps)(BacktestResult);
export { page as default }
 */